import initialState from './initialState';
import {
  FETCH_DRIVER_INIT,
  FETCH_DRIVER_SUCCESS,
  FETCH_DRIVER_FAILURE,
  FETCH_EQUIP_INIT,
  FETCH_EQUIP_SUCCESS,
  FETCH_EQUIP_FAILURE,
  FETCH_TEST_INIT,
  FETCH_TEST_SUCCESS,
  FETCH_TEST_FAILURE,
  IF_DRIVER_EXIST,
  ADD_ASIGNATION,
  DELETE_ASIGNATION,
  CHANGE_NAME,
  IS_DUPLICATE
} from '../../actions/allocator/types';

export default function allocator(state = initialState, action) {
  switch (action.type) {
    // checked for duplication
    case IS_DUPLICATE: {
      let duplicateDriver = [...state.asignation]
        .map(item => {
          return item.person;
        })
        .includes(action.payload);
      let duplicateEquip = [...state.asignation]
        .map(item => {
          return item.equip;
        })
        .includes(action.payload);
      return {
        ...state,
        isDuplicate: duplicateDriver || duplicateEquip
      };
    }
    // delete an asignation that is located in memory
    case DELETE_ASIGNATION: {
      let second = [...state.asignation].filter((item, i, arr) => {
        return item.id != action.payload;
      });
      return {
        ...state,
        asignation: second
      };
    }
    // changed the name of the driver when selected another name in the list
    case CHANGE_NAME: {
      let obj = state.asignation[action.payload.index];
      let updatedObject = { ...obj, person: action.payload.name };
      const newDataItem = [
        ...state.asignation.slice(0, parseInt(action.payload.index)),
        updatedObject,
        ...state.asignation.slice(parseInt(action.payload.index) + 1)
      ];
      return {
        ...state,
        asignation: [...newDataItem]
      };
    }

    case ADD_ASIGNATION: {
      return {
        ...state,
        asignation: [...state.asignation, action.payload]
      };
    }
    case FETCH_DRIVER_INIT:
      return {
        ...state,
        loading: true
      };

    case FETCH_DRIVER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_DRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        datos: action.payload
      };

    /*equip*/
    case FETCH_EQUIP_INIT:
      return {
        ...state,
        equip: {
          ...state.equip,
          loading: true
        }
      };

    case FETCH_EQUIP_FAILURE:
      return {
        ...state,
        equip: {
          ...state.equip,
          loading: false,
          error: action.payload
        }
      };

    case FETCH_EQUIP_SUCCESS:
      return {
        ...state,
        equip: {
          ...state.equip,
          loading: false,
          datos: action.payload,
          error: null
        }
      };

    case FETCH_TEST_INIT:
      return {
        ...state,
        test: {
          ...state.test,
          loading: true
        }
      };
    case FETCH_TEST_FAILURE:
      return {
        ...state,
        test: {
          ...state.test,
          loading: false,
          error: action.payload
        }
      };

    case FETCH_TEST_SUCCESS:
      return {
        ...state,
        test: {
          ...state.test,
          loading: false,
          datos: action.payload,
          error: null
        }
      };
    case IF_DRIVER_EXIST: {
      let driver = action.payload;
      let alias = state.test.datos ? state.test.datos : [];
      let isDriver = alias.data.map(item => item.alias);
      return {
        ...state,
        exist: isDriver
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/allocator/index.js